import React from 'react'
import Button from 'react-bootstrap/esm/Button'
import Card from 'react-bootstrap/esm/Card'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import Helpers from '../../Components/Helpers/Helpers'
import AppLayoutPublic from '../Layout/LayoutPublic'
import { useEffect } from 'react'

const CustomersPublicoMessages = () => {
  const history = useHistory()
  const { type } = useParams();

  useEffect(() => {
    if (type === 'success') {
      localStorage.removeItem('id_customers_kit_public')
      localStorage.removeItem('id_customers_kit_public_upline')
    }
  }, [type])

  return <AppLayoutPublic type="clientes">
    <Card>
      <Card.Body className="d-flex align-items-center flex-column pt-5 pb-5">
        {type === 'success' && <i className="fa fa-check-circle text-success fa-5x mb-4"></i>}
        {type === 'error-pago' && <i className="fa fa-times-circle text-danger fa-5x mb-4"></i>}
        <h1><strong>
          {type === 'success' && '¡Pago Realizado!'}
          {type === 'error-pago' && '¡Error al procesar el pago!'}
        </strong></h1>
        {type === 'success' && <p>
          Revisar tu correo electrónico para más información.
        </p>}
        {<div>
          <Button onClick={_ => history.push(Helpers.config.convertUrl({ url: '/alta-de-cliente/' }))}>
            Regresar
          </Button>
        </div>}
      </Card.Body>
    </Card>
  </AppLayoutPublic>
}

export default CustomersPublicoMessages